<template>
	<v-dialog
		persistent
		max-width="600"
		v-model="dialog"
	>
		<v-card v-if="e">
			<v-card-title>
				<span class="dialog-title">{{e.title}}</span>
			</v-card-title>
			<v-card-text class="pb-1">
				{{e.message}}
			</v-card-text>
			<v-card-actions class="mx-4 pb-4">
				<v-btn
					:color="e.positiveWarning ? 'error' : 'blue darken-1'"
					text
					@click="positiveAction"
					outlined
					small
				>
					{{e.positiveActionTitle}}
				</v-btn>
				<v-btn
					color="blue darken-1"
					text
					@click="negativeAction"
					outlined
					small
				>
					{{e.negativeActionTitle}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		data: function(){
			var data = {
				dialog: false,
				e: null
			};
			return data;
		},
		beforeCreate(){
			this.$vBus.$on("confirm", function(e){
				this.dialog = true;
				this.e = e;
			}.bind(this));
		},
		methods: {
			positiveAction(){
				this.dialog = false;
				if (this.e.positive) {
					this.e.positive();
				}
			},
			negativeAction(){
				this.dialog = false;
			}
		}
	}
</script>